import { useEffect, useState } from "react";
import logo from "./pictures/logo.png";
import "./styles/Login.css";

const backendUrl = "https://sokonishushi.co.tz/api/login.php";

export default function Login() {
    const [phonenumber, setPhonenumber] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);
    const [showSplash, setShowSplash] = useState(true);

    // Show splash screen for 2 seconds
    useEffect(() => {
        const timer = setTimeout(() => {
            setShowSplash(false);
        }, 2000);
        return () => clearTimeout(timer);
    }, []);

    const handleLogin = async () => {
        setError("");
        
        if (!phonenumber.trim()) {
            setError("Phone number is required");
            return;
        }
        
        const phoneRegex = /^[0-9]{10}$/;
        if (!phoneRegex.test(phonenumber.trim())) {
            setError("Please enter a valid 10-digit phone number");
            return;
        }

        if (!password.trim()) {
            setError("Password is required");
            return;
        }

        if (password.length !== 4 || !/^\d{4}$/.test(password)) {
            setError("Password must be 4 digits");
            return;
        }

        setLoading(true);

        const payload = { 
            phonenumber: phonenumber.trim(), 
            password: password 
        };

        try {
            const res = await fetch(backendUrl, {
                method: "POST",
                headers: { 
                    "Content-Type": "application/json",
                    "Accept": "application/json"
                },
                body: JSON.stringify(payload),
            });

            if (!res.ok) {
                const errorData = await res.json();
                throw new Error(errorData.error || `HTTP ${res.status}`);
            }

            const data = await res.json();

            if (data.success && data.token) {
                // Store user data
                localStorage.setItem("token", data.token);
                localStorage.setItem("user", JSON.stringify(data.user));
                localStorage.setItem("role", data.user.role);
                localStorage.setItem("names", data.user.names);
                localStorage.setItem("name", data.user.names);
                localStorage.setItem("staff_id", data.user.id);
                localStorage.setItem("phonenumber", data.user.phonenumber);
                
                // Redirect based on role
                if (data.user.role === "admin") {
                    window.location.href = "/dashboard";
                } else {
                    window.location.href = "/staff-attendance";
                }
            } else {
                setError(data.error || "Login failed");
            }
        } catch (err) {
            console.error("Login error:", err);
            setError(err.message || "Server error. Please try again.");
        } finally {
            setLoading(false);
        }
    };

    const handleKeyPress = (e) => {
        if (e.key === "Enter" && !loading) {
            handleLogin();
        }
    };

    // Radio Frequency Style Loading Screen
    if (showSplash) {
        return (
            <div className="splash-screen">
                <div className="splash-content">
                    <div className="rf-signal">
                        <div className="rf-wave rf-wave-1"></div>
                        <div className="rf-wave rf-wave-2"></div>
                        <div className="rf-wave rf-wave-3"></div>
                        <div className="rf-wave rf-wave-4"></div>
                        <div className="rf-dot"></div>
                    </div>
                    <div className="splash-text">
                        <h1>MARAFIKI</h1>
                        <p>Attendance System</p>
                    </div>
                    <div className="loading-dots">
                        <span></span>
                        <span></span>
                        <span></span>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="login-container">
            <div className="login-card">
                <div className="brand-header">
                    <h1 className="brand-title">WELCOME TO <span>MARAFIKI</span></h1>
                    <div className="brand-subtitle">ATTENDANCE SYSTEM</div>
                    <div className="brand-mas">(MAS)</div>
                </div>
                
                <div className="logo-wrapper">
                    <img src={logo} alt="Logo" className="logo-circle" />
                </div>
                
                <p className="subtitle">Please login to continue</p>

                <input
                    type="tel"
                    placeholder="Phone Number"
                    value={phonenumber}
                    onChange={(e) => setPhonenumber(e.target.value)}
                    onKeyPress={handleKeyPress}
                    disabled={loading}
                    autoComplete="tel"
                    maxLength="10"
                />

                <input
                    type="password"
                    placeholder="Password (4 digits)"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    onKeyPress={handleKeyPress}
                    disabled={loading}
                    autoComplete="off"
                    maxLength="4"
                    pattern="\d{4}"
                />

                <button onClick={handleLogin} disabled={loading}>
                    {loading ? "Logging in..." : "Login"}
                </button>

                {error && <p className="error">{error}</p>}
            </div>
        </div>
    );
}